import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { isEmptyString, isNull } from '../../util/check';

@Component({
	selector: 'fn-avtar-text',
	templateUrl: './fn-avtar-text.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnAvtartextComponent implements OnInit {
	@Input() initials = '';
	@Input() maxInitial = '';
	@Input() imgUrl = '';
  @Input() textClass =' ';
  @Input() imgClass=' ';

	uiMap = {
		initialWords: '',
		bgColor: '',
		isShowAvatar: false,
	};

	ngOnInit(): void {
    this.setDefaultData();
	}

  private setDefaultData(){
    this.uiMap.isShowAvatar = isNull(this.imgUrl) || isEmptyString(this.imgUrl);
		if (this.uiMap.isShowAvatar) {
			this.uiMap.initialWords = this.getInitials(
				this.initials || '',
				this.maxInitial || '2'
			);
			this.uiMap.bgColor = this.generateRandomColor();
		}
  }

	updateImg(initialWords: string, imgUrl: string) {
		this.initials = initialWords;
		this.imgUrl = imgUrl;
		this.setDefaultData();
	}

	generateRandomColor(): string {
		const letters = '0123456789ABCDEF';
		let color = '#';
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}

	getInitials(textString: string, noOfChar: string): string {
		if (isNull(textString) || isEmptyString(textString)) {
			return '';
		}
		let numChars = parseInt(noOfChar);
		numChars = isNaN(numChars) ? 2 : numChars;

		const words = textString.split(' ');
		if (words.length === 1) {
			return textString.slice(0, numChars).toUpperCase();
		}
		return (words[0][0] + (numChars > 1 ? words[1][0] : '')).toUpperCase();
	}
}
